export default __webpack_public_path__ + "static/media/animal-10.1ec63741.svg";